import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[ivDateValidatorDirective]'
})
export class DateValidatorDirective {
  @Output() isValidDateEmitter;

  constructor(private elementRef: ElementRef) {
    this.isValidDateEmitter = new EventEmitter();
  }

  @HostListener('blur') onBlur() {
    if (this.elementRef && this.elementRef.nativeElement.value) {
      // ** regular expression to accept only DD/MM/YYYY */
      const regexp = /(^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$)/;
      const isValidDate = regexp.test(this.elementRef.nativeElement.value);
      this.isValidDateEmitter.emit({
        controlId: this.elementRef.nativeElement.id,
        isValidDate: isValidDate
      });
    }
  }
}
